import React from 'react';

import { formatPrice } from '@utils/currency';
import { useIsChain } from '@utils/useIsChain';

import { NavigationCell } from '../NavigationCell';

const usePrice = (row) => {
	const isChain = useIsChain();
	if (isChain) {
		const isSamePrice = formatPrice(row.priceMin, row.currency) === formatPrice(row.priceMax, row.currency);
		if (isSamePrice) {
			return formatPrice(row.priceMin, row.currency);
		}
		return `${formatPrice(row.priceMin, row.currency)} - ${formatPrice(row.priceMax, row.currency)}`;
	}
	return formatPrice(row.price, row.currency);
};

const Price = ({ row }) => {
	const price = usePrice(row);
	return <NavigationCell barcode={row.barcode}>{price}</NavigationCell>;
};

export { Price, usePrice };
